module.exports = __webpack_public_path__ + "img/l_h2.4161b16e.png";